/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Aborted_ToastInputs */



/**
* | output |
* | --- |
* | "Video export was aborted" |
*
* @param {Video_Export_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_aborted_toast = /** @type {((inputs?: Video_Export_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'exportation video a ete annulee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Videoexport wurde abgebrochen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'esportazione del video è stata interrotta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт видео был прерван.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se canceló la exportación de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频导出已中止")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオのエクスポートが中止されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो निर्यात प्रक्रिया रोक दी गई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A exportação do vídeo foi cancelada.")
	return /** @type {LocalizedString} */ ("Video export was aborted")
});